import { Injectable } from "@angular/core";

import { CustomFormControl } from "digital-core";

@Injectable({
    providedIn: "root"
  })
export class NotEqualValidator {
  constructor() {}

  notEqualAddresses (valuesToCompare: string[], component: CustomFormControl) {
    let componentValue: string = component.value;
    if (!componentValue) {
      return null;
    }
    if (!valuesToCompare.includes(component.value)) {
      return null;
    } else {
      return { secondaryAddressNotEqualThanProposed: { valid: false } };
    }
  }

  matchValues(matchToControl: string ) {
    return (control: CustomFormControl) => {
      return !!control.parent &&
        !!control.parent.value &&
        control.value === control.parent.controls[matchToControl].value ? null : { isMatching: false };
    };
}

//  proposedAddressNotEqualThanSecondaryOrOwner (valuesToCompare: string[], component: CustomFormControl) {
//     let componentValue: string = component.value;
//     if (!componentValue) {
//       return null;
//     }
//     if (!valuesToCompare.includes(component.value)) {
//       return null;
//     } else {
//       return { secondaryAddressNotEqualThanProposed: { valid: false } };
//     }
//   }

//   ownerNotEqualThanProposedOrSecondary (valuesToCompare: string[], component: CustomFormControl) {
//     let componentValue: string = component.value;
//     if (!componentValue) {
//       return null;
//     }
//     if (!valuesToCompare.includes(component.value)) {
//       return null;
//     } else {
//       return { secondaryAddressNotEqualThanProposed: { valid: false } };
//     }
//   }
}
